import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { StepContentProps } from "./BusinessInfoTypes";
import { FormTextField } from "./FormTextField";
import { ControlledFileInput } from "./ControlledFileInput";
import { Box } from "@mui/material";
import { useThemeMode } from "../../contexts/ThemeModeContext";

/**
 * Step 3: Customer Testimonials (Simple Controlled Form)
 */
export const StepTestimonials: React.FC<StepContentProps> = ({
  formData,
  setFormData,
}) => {
  const { mode } = useThemeMode();
  const addTestimonial = () => {
    setFormData((prev) => ({
      ...prev,
      testimonials: [
        ...prev.testimonials,
        {
          id: crypto.randomUUID(),
          clientName: "",
          file: [],
        },
      ],
    }));
  };

  const updateTestimonial = (
    index: number,
    updatedItem: (typeof formData.testimonials)[number],
  ) => {
    setFormData((prev) => {
      const updated = [...prev.testimonials];
      updated[index] = updatedItem;
      return { ...prev, testimonials: updated };
    });
  };

  const removeTestimonial = (index: number) => {
    setFormData((prev) => ({
      ...prev,
      testimonials: prev.testimonials.filter((_, i) => i !== index),
    }));
  };

  return (
    <div className="space-y-6 "   style={{ overflowY: "auto", maxHeight: "540px" }}>
      <Typography
        variant="h5"
        component="h2"
        className="text-gray-700"
        sx={{ mt: 3, mb: 3 }}
      >
        3. Customer Testimonials
      </Typography>
      <Box
        sx={{
          p: 3, // padding = 24px
          border: mode === "dark" ? "1px solid #374151" : " 1px solid #e5e7eb", // adjust colors if needed

          borderRadius: 2,
        }}
      >
        {formData.testimonials.map((item, index) => (
          <div key={item.id} className="border rounded-lg p-4 space-y-3">
            <Typography variant="subtitle1" fontWeight={600}>
              Testimonial {index + 1}
            </Typography>

            {/* Client Name */}

            <FormTextField
              label="Client Name / Company (Optional)"
              value={item.clientName}
              onChange={(value: any) =>
                updateTestimonial(index, {
                  ...item,
                  clientName: value,
                })
              }
            />

            {/* File Upload */}
            <ControlledFileInput
              label="Upload Testimonial Document (PDF/Image) (Optional)"
              value={item.file}
              folderPath="/Business_info/testimonial"
              multiple={false}
              onChange={(files: any) =>
                updateTestimonial(index, {
                  ...item,
                  file: files,
                })
              }
            />

            {formData.testimonials.length > 1 && (
              <Button
                variant="text"
                color="error"
                onClick={() => removeTestimonial(index)}
              >
                Remove testimonial
              </Button>
            )}
          </div>
        ))}

        <Button variant="outlined" onClick={addTestimonial}>
          Add Testimonial
        </Button>
      </Box>
    </div>
  );
};
